
import { Model, SCENE_EVENTS } from './components/MVC/Model';
// import { ClientJS } from 'clientjs';
import { ModeView } from './ModeView';
import { ModeEdit } from './ModeEdit';
import $ from 'jquery';
import { Preloader } from './components/Preloader/Preloader';
import { Socket } from './socket/Socket';
import UserProfile from './components/Modals/Profile/UserProfile';
import Notification from './components/Modals/Notifications/Notification';
// import WebRTC from './components/WebRTC/WebRTC';

import { Navbar } from './components/Navbar/Navbar';
import JoinSceneModal from './components/Modals/Profile/JoinScene';
import JoinWorld from './components/Modals/Profile/JoinWorld';
import { DefaultNavbar } from './components/Navbar/DefaultNavbar';
import { ContributeHelper } from './components/MVC/contributeHelper';
import { RoomGuestHelper } from './components/MVC/roomGuestHelper';
import { FriendsHelper } from './components/MVC/friendsHelper';
import SendOfflineMessageModal from './components/Modals/Profile/SendOfflineMessageModal';
import MeetingModeController from './components/Controllers/MeetingModeController';
import OneOnOneController from './components/Controllers/OneOnOneController';
import TourModeController from './components/Controllers/TourModeController';
import ModalHandler from './components/engine/helpers/ModalHandler.js';
import { UnifiedAntMediaController } from './components/WebRTC/seperatedControllers/UnifiedAntMediaController.js';
import TourUnifiedController from './components/Controllers/TourMode/TourUnifiedController.js';
import UserProfileModal from './components/Modals/Profile/UserProfileModal.js';
import ChatPanel from './components/Chat/ChatPanel.js';
import NewChatComponent from './components/Chat/NewChatComponent.js';
import PeoplesList from './components/Peoples/PeoplesList.js';
import { applyForcedWorldLanguage, applyNavigationFeatureVisibility } from './components/engine/helpers/worldHelpers';
import ChessModeController from './components/Controllers/Chess/ChessModeController.js';
import { SOCKET_EVENTS } from './socket/Events';
import { WEBRTC_EVENTS } from './constants/webrtc';
import { FEATURE_NAMES } from './components/MVC/rolesHelper';
import { requestMediaPermissions } from './components/engine/helpers/userMediaHelper';
// import GridModeController from "./components/Controllers/GridModeController";

// import { Socket } from './socket/Socket';
// import { Chat } from './components/Chat/Chat';
// Create a new ClientJS object
// const client = new ClientJS();
// // Get the client's fingerprint id
// const fingerprint = client.getFingerprint();
// // Print the 32bit hash id to the console
// console.log('fingerprint: ',fingerprint);
//const queryString = window.location.search;
const urlParams = new URLSearchParams(window.location.search);
const r = urlParams.get('r');
const worldID = urlParams.get('id');
const tourId = urlParams.get('tourId');
const isEmbed = urlParams.get('isEmbed');
const custom = urlParams.get('custom'); //custom back
const customExit = (urlParams.get('customExit') || urlParams.get('customexit') || '').trim();
const security = urlParams.get('security');
const autoSeat = urlParams.get('autoseat');

function containsSubstring(url, substring) {
  return url.includes(substring);
}

function getQueryParamValue(paramName) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(paramName);
}

function clearPeerActionParams() {
  const url = new URL(window.location.href);
  url.searchParams.delete('peerAction');
  url.searchParams.delete('peerId');
  window.history.replaceState({}, '', url.pathname + url.search);
}

function findPeerUser(socket, peerId) {
  const users = socket.getUsersObject() || {};
  if (users[peerId]) {
    return users[peerId];
  }
  return Object.values(users).find((user) => user && String(user.userId) === String(peerId)) || null;
}

function startPeerActionFromSpaces(model, socket) {
  const peerAction = getQueryParamValue('peerAction');
  const peerId = getQueryParamValue('peerId');
  if (!peerAction || !peerId || model.config.isGuest) {
    return;
  }

  let started = false;
  const run = async () => {
    if (started) {
      return;
    }
    started = true;
    socket.removeEventListener(SOCKET_EVENTS.INIT_USERS, run);
    clearPeerActionParams();
    const user = findPeerUser(socket, peerId);
    if (!user) {
      return;
    }
    if (peerAction === 'chat') {
      if (!await model.validatePlanFeature(FEATURE_NAMES.ONE_TO_ONE_CHAT)) {
        return;
      }
      socket.dispatchEvent({ type: SOCKET_EVENTS.ADD_ONE_ON_ONE_CHAT, data: user });
      return;
    }
    if (peerAction === 'call') {
      if (!await model.validatePlanFeature(FEATURE_NAMES.VIDEO_CALLS)) {
        return;
      }
      if (!(await requestMediaPermissions('all', model))) {
        return;
      }
      model.dispatchEvent({ type: WEBRTC_EVENTS.WEBRTC_VIDEO_ONE_ON_ONE, data: { item: user } });
    }
  };

  if (socket.initUsers) {
    run();
    return;
  }
  socket.addEventListener(SOCKET_EVENTS.INIT_USERS, run);
}

function whenDomReady(fn) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fn, { once: true });
  } else {
    fn();
  }
}

function cacheBaglessLogo() {
  try {
    if (localStorage.getItem('bagless_logo')) {
      $("#ref_logo").remove();
      return;
    }
    const thumbnailImageObj = document.getElementById('ref_logo');
    if (!thumbnailImageObj || !thumbnailImageObj.width) {
      return;
    }
    const canvas = document.createElement('canvas');
    canvas.width = thumbnailImageObj.width;
    canvas.height = thumbnailImageObj.height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(thumbnailImageObj, 0, 0);
    localStorage.setItem('bagless_logo', canvas.toDataURL('image/png'));
  } catch (e) { /* ignore */ }
}

export let tourID = "default";

const reqUrl = $('#virtualRealityContainer').attr('data-open-world-url');
window.aptis.url = reqUrl;

let viewType;
let useView;
let CONFIG = {
  "socketUrl": "ws://localhost:3029",
  "sessionId": "636f5138e3684331fcfdd7af6f1b3814",
  "userId": Math.floor(Math.random() * 100) + 1,
  "userName": `3ojan studio d.o.o.`,
  "userAvatarUrl": "./textures/avatar.jpg",
  "userVideoOn": false,
  "email": "3ojans@gmail.com",
  "wordpressEditProfileUrl": "https://bagless.io/?p=306",
  "temporaryFileUploadUrl": "/apprc/web/index.php?r=media/upload-file",
  "addImageUrl": "/apprc/web/index.php?r=media/add-image",
  "buyLocationTicketURL": "/apprc/web/index.php?r=worlds/buy-location-ticket",
  "validateLocationTicketURL": "/apprc/web/index.php?r=purchases/validate-location-ticket",
  "worldId": 1,
  "audioLevels": 0,
  "currentUserMood": 1,
  "sceneId": 1,
  "hasProfile": "",
  "isGuest": false,
  "sceneName": "Pronstorfer Krug"
};


$(".email_section").hide();
$(".bio_section").hide();
$(".birthdate_section").hide();
$(".location_section").hide();


let preloader;


document.onreadystatechange = function (e) {

  if (document.readyState === 'interactive') {
    //dom is ready, window.onload fires later
    $('.displayNone').removeAttr('style');
    preloader = new Preloader();
    if (CONFIG.splashImage) {
      preloader.setSplashLogoSrc(CONFIG.splashImage);
    }
  }
};


if (window.location.pathname === '/worlds/view' || r === 'worlds/view') {
  aptis.view = new Class({
    _worldId: 0,
    worldConfig: [],
    _baseUrl: '',
    _urls: {},
    initController: function (config, worldId, debugModeEnabled, socketConfig = null) {
      this.worldConfig = config || {};
      this._worldId = worldId;
      this._debugModeEnabled = debugModeEnabled;
      this._socketConfig = socketConfig;
      CONFIG = { ...CONFIG, ...this._socketConfig, security };
      if (preloader && CONFIG.splashImage) {
        preloader.setSplashLogoSrc(CONFIG.splashImage);
      }
    }
  });


  whenDomReady(() => {
    const model = new Model({ mode: 'view', CONFIG });
    let url = window.location.host;
    let substring = "apprc";
    tourID = window.origin + `-rc-tour-${CONFIG.worldId}`;
    if (containsSubstring(url, substring)) {
      tourID = window.origin + `-tour-${CONFIG.worldId}`;
    }

    let view;
    let socket;
    model.startTourWithIdFromInvite = tourId;
    model.isEmbed = isEmbed;
    model.autoSeat = autoSeat;
    model.customBack = custom === "back";
    model.customExit = customExit;

    model.addEventListener(SCENE_EVENTS.SCENE_DATA_RECIEVED, () => {
      socket = new Socket({ model, CONFIG });

      window.socket = socket;
      const friendsHelper = new FriendsHelper({ model, socket }); //TODO send from backand if world haveContributors

      let navbar;
      if (!model.isEmbed !== "0") {
        navbar = new Navbar({ model });
        applyForcedWorldLanguage(model.sceneData);
      }

      // put notification after navbar to attach system notifications to navbar
      const traffic = new Notification({ model, socket });

      const userProfile = new UserProfile({ model });
      const newUserProfile = new UserProfileModal({ model });
      const joinSceneModel = new JoinSceneModal({ model });
      const joinWorldModal = new JoinWorld({ model });
      const sendOfflineMessagesModal = new SendOfflineMessageModal({ model, socket });
      model.sendOfflineMessagesModal = sendOfflineMessagesModal;

      // Init chat panel, please put this before the oneOnOneController
      const chat = new ChatPanel({ model });
      model.chatPanel = chat
      const peoplesList = new PeoplesList({ model })
      applyNavigationFeatureVisibility({ model, chatPanel: chat, peoplesList });

      // const gridModeController = new GridModeController({ model, socket })
      const meetingModeController = new MeetingModeController({ model, socket })
      const oneOnOneController = new OneOnOneController({ model, socket })
      startPeerActionFromSpaces(model, socket);
      // const canvasController = new CanvasController({ model, socket });
      // model.canvasController = canvasController;
      const tourModeController = new TourModeController({ model, socket });
      const chessModeController = new ChessModeController({ model, socket });
      model.chessModeController = chessModeController;


      const tourUnifiedController = new TourUnifiedController({ model, socket });

      const welcomeModal = new ModalHandler('#welcomeScreen');
      const guestWelcomeModal = new ModalHandler('.modal.guest-welcome-modal-holder');
      const selfCheck = new ModalHandler('#selfCheckModal');
      const welcomeCheckModal = new ModalHandler('#welcomeCheckModal');
      const permissionDeniedModal = new ModalHandler('.permissionDenied-modal');
      const videoGallery = new ModalHandler('#videoGalleryModal');
      const postitModal = new ModalHandler('#postitModal');

      if (!model.isMobile) {
        $("#orientation-warning").remove();
      }

      if (model.isEmbed === "0") {
        ///kill notifications, initsettrue
        model.initDeviceCheck = true;
        model.alert = () => { };
        model.success = () => { };
        model.info = () => { };
        const isEmbeded = new ModalHandler('.isEmbeded-modal-holder');
        // const title = $("#guest-welcome-title").html();
        // $("#isEmbeded-title").html(`${title} ${model.sceneData.sceneName || model.sceneData.name}`);
        $(".isEmbeded-modal-holder").addClass("is-active");
        $(guestWelcomeModal).removeClass("is-active")
        //$('.modal:not(.isEmbeded-modal-holder):not(.take-seat)').remove();

        // $('.modal:not(.isEmbeded-modal-holder):not(.take-seat):not(.guest-welcome-modal-holder)').remove();
        $(".navbar-holder").remove();
        $(".chat-all-container").remove();

        $(".world-top-nav__menu_area").remove();
        $("#fullscreen_toggle").remove();
        $("#page_media_mute_toggle").remove();
        $(".language-button.world-top-nav__menu_area").remove();
        if (model.sceneData.space_type === 'premium') {
          $(".world-top-nav__logo_area").remove();
          $("#isEmbeded-create-space").remove();
        }
        $("#isEmbeded-create-space").on("click", () => {
          window.location.href = "/spaces";
        });
        $("#world-button-nav__default-right").remove();
        $(".world-bottom-nav").hide();

        $(".people-all-container").remove();
        $("#welcomeScreen").remove();
        $(".guest-welcome-modal-holder").remove();
        $("#permissionDeniedModal").remove();
        $("#welcomeCheckModal").remove();
        $("#orientation-warning").remove();

        $('#isEmbeded-welcome').on('click', (e) => {
          $(guestWelcomeModal).addClass("is-active");
          e.preventDefault();
          e.stopPropagation();
          // $(".isEmbeded-modal-holder").removeClass("is-active");
          // socket.customStart(); //not sure if we'll need this in future

          const url = `${window.location.protocol}//${window.location.host}/worlds/view?id=${model.config.worldId}&custom=back&security=${getQueryParamValue('security')}&isEmbed=1`;

          // Create a temporary anchor element
          const tempLink = document.createElement('a');
          tempLink.href = url;
          tempLink.target = '_blank'; // Open in a new tab

          // Append it to the body, click it, and then remove it
          document.body.appendChild(tempLink);
          tempLink.click();
          document.body.removeChild(tempLink);
        });

      }
      if (model.isEmbed === "1") {
        $("#burger-menu").remove();
        $("#shareToggle").remove();
        $("#exit_app").remove();
        $(".left-nav-side .divider").remove();
        $(".navbar-holder").remove();
        $(".guest-welcome-modal-holder footer").remove();
        $("#welcomeScreen").remove();
      }

    });
    const callback = () => {

      if (view)
        return;
      viewType = 'view';
      $('body').addClass('view-mode');

      // const webRtc = new WebRTC({ socket, model }); //mine old
      // const webRtc = new WebRTC({ socket, model })
      const unifiedAntMediaController = new UnifiedAntMediaController({ model });
      view = new ModeView({ model, preloader, socket });
      // const webRtc = new WebRtc({ socket, model });
    };

    model.getSceneData({
      url: reqUrl, onOk: () => { callback(); }
    });

    cacheBaglessLogo();
  });

  viewType = 'view';
  useView = true;
  //console.log(viewType);
}


if (window.location.pathname === '/worlds/update' || r === 'worlds/update') {
  $("#welcomeCheckModal").remove();
  let URLS = {};
  //values passed from PHP WorldsController here => URLS (not in window.aptis_urls any more)
  aptis.edit = new Class({
    _worldId: 0,
    _securityHash: '',
    _baseUrl: '',
    _urls: {},
    initController: function (baseUrl, worldId, securityHash, debugModeEnabled, urls) {
      this._baseUrl = baseUrl;
      this._worldId = parseInt(worldId + '');
      this._securityHash = securityHash;
      this._urls = urls;
      URLS = { ...this._urls, securityHash };
      CONFIG = { ...CONFIG, ...this._urls, security };
      if (preloader && CONFIG.splashImage) {
        preloader.setSplashLogoSrc(CONFIG.splashImage);
      }
    }
  });

  whenDomReady(() => {
    const model = new Model({ mode: 'edit', CONFIG });
    window.model = model;
    model.initDeviceCheck = true;
    let view;
    const traffic = new Notification({ model });
    const navBar = new DefaultNavbar();

    const callback = () => {

      if (view)
        return;

      model.URLS = URLS;
      model.creator = URLS.creator;
      const contributeHelper = new ContributeHelper({ model }); //TODO send from backand if world haveContributors 
      const guestsHelper = new RoomGuestHelper({ model }); //TODO send from backand if world haveContributors 
      view = new ModeEdit({ model, URLS, preloader });
      $('body').toggleClass('edit-mode');

    };

    model.getSceneData({
      url: reqUrl, onOk: () => { callback(); }
    });

  });


}

const createScene = useView ? ModeView : ModeEdit;

export default createScene;

